import { render, staticRenderFns } from "./registration-confirmation-text-block.vue?vue&type=template&id=ea5acab2&"
import script from "./registration-confirmation-text-block.vue?vue&type=script&lang=js&"
export * from "./registration-confirmation-text-block.vue?vue&type=script&lang=js&"
import style0 from "./registration-confirmation-text-block.vue?vue&type=style&index=0&id=ea5acab2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea5acab2')) {
      api.createRecord('ea5acab2', component.options)
    } else {
      api.reload('ea5acab2', component.options)
    }
    module.hot.accept("./registration-confirmation-text-block.vue?vue&type=template&id=ea5acab2&", function () {
      api.rerender('ea5acab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/parts/registration-confirmation-text-block.vue"
export default component.exports